<script>
export default {
  props: {
    component: Object,
    handler: Object,
  },
};
</script>

<template>
  <f-button
    :type="component.type"
    :pending="pending"
    @click="
      pending = true;
      handler.action(component, 'call', []);
      pending = false;
    "
    >{{ component.label }}<f-icon :icon="component.icon"></f-icon
  ></f-button>
</template>

<style lang="scss" scoped>
</style>